import { GridApi, GridOptions } from 'ag-grid-community';
import React, { ComponentType, FC, useEffect, useState } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { isChildNode } from 'utils/is-child-node';
import { useOnGridReady } from './use-on-grid-ready';

export const withSharedHorizontalScroll = <
  T extends Pick<GridOptions, 'onGridReady'>,
>(
  Component: ComponentType<T>,
): FC<T> => {
  const Next: FC<T> = ({ onGridReady: onReady, ...props }) => {
    const [api, setApi] = useState<GridApi | null>(null);
    const [, , onGridReady] = useOnGridReady(onReady, (event) =>
      setApi(event.api),
    );

    useEffect(() => {
      if (api == null) {
        return () => {};
      }
      const eBodyViewport = document.querySelector(
        '[ref=eBodyViewport]',
      )! as HTMLDivElement;
      const eCenterViewport = document.querySelector(
        '[ref=eCenterViewport]',
      )! as HTMLDivElement;
      const headerRoot = document.querySelector(
        '[ref=headerRoot]',
      )! as HTMLDivElement;
      const isChildOfCenterViewport = isChildNode(['ag-center-cols-container']);
      const headerListener = (evt: WheelEvent) => {
        evt.preventDefault();
        if (evt.deltaX !== 0) {
          eCenterViewport.scroll({
            left: eCenterViewport.scrollLeft + evt.deltaX,
          });
        }
      };

      headerRoot.addEventListener('wheel', headerListener);
      const bodyListener = (evt: WheelEvent) => {
        if (
          !isChildOfCenterViewport(evt.target as HTMLElement) &&
          evt.deltaX !== 0
        ) {
          evt.preventDefault();
          eCenterViewport.scroll({
            left: eCenterViewport.scrollLeft + evt.deltaX,
          });
        }
      };

      eBodyViewport.addEventListener('wheel', bodyListener);

      return () => {
        headerRoot.removeEventListener('wheel', headerListener);
        eBodyViewport.removeEventListener('wheel', bodyListener);
      };
    }, [api]);

    return <Component {...(props as any)} onGridReady={onGridReady} />;
  };

  return setDisplayName(
    wrapDisplayName(Component, 'WithSharedHorizontalScroll'),
  )(Next);
};
